import { useFormContext } from 'react-hook-form'
import { BefehlFormAuftrag } from '../Generic'
import { useTranslation } from 'react-i18next'

export interface Auftrag29_30FormProps {
  readOnly: boolean
  'data-testid': string
  activateEmptyFieldWarnings: boolean
}

export default function Auftrag29_30Form({
  readOnly,
  'data-testid': testId,
  activateEmptyFieldWarnings
}: Readonly<Auftrag29_30FormProps>) {
  const { control } = useFormContext()
  const { t } = useTranslation('ui-befehle')

  return (
    <BefehlFormAuftrag
      auftragKennung="29.30"
      label={t('auftraege.29_30.label')}
      fieldName="auftrag_29_30.enabled"
      control={control}
      readOnly={readOnly}
      testId={testId}
      activateEmptyFieldWarnings={activateEmptyFieldWarnings}
    >
      <span data-testid={`${testId}-text`}>{t('auftraege.29_30.label')}</span>
    </BefehlFormAuftrag>
  )
}
